<template>
  <div class="c-searchLegalBanner">
    <a
      :href="searchLegalBannerTo"
      target="_brank"
      rel="noopener"
      class="c-searchLegalBanner_banner"
    >
      <img
        :src="imagePath(searchLegalBanner.img)"
        :alt="searchLegalBanner.alt"
        loading="lazy"
        decoding="async"
      >
    </a>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'

const LEGAL_BANNER_DEFAULT = {
  alt: 'みんなが投稿した弁護士への無料Q&A公開中',
  cnClicked: 'banner_all',
  img: 'legal_default',
  path: '/bbses'
}

const LEGAL_BANNER_CATEGORY = [
  {
    parentCategoryId: 1,
    alt: '【男女トラブル】みんなが投稿した弁護士への無料Q&A公開中',
    cnClicked: 'banner_marrige',
    img: 'legal_marrige',
    path: '/bbses?category_ids%5B%5D=1'
  },
  {
    parentCategoryId: 2,
    alt: 'みんなが投稿した弁護士への無料Q&A公開中',
    cnClicked: 'banner_ trouble',
    img: 'legal_default',
    path: '/bbses'
  },
  {
    parentCategoryId: 3,
    alt: 'みんなが投稿した弁護士への無料Q&A公開中',
    cnClicked: 'banner_fortune',
    img: 'legal_default',
    path: '/bbses'
  },
  {
    parentCategoryId: 4,
    alt: 'みんなが投稿した弁護士への無料Q&A公開中',
    cnClicked: 'banner_beauty',
    img: 'legal_default',
    path: '/bbses'
  },
  {
    parentCategoryId: 5,
    alt: 'みんなが投稿した弁護士への無料Q&A公開中',
    cnClicked: 'banner_living',
    img: 'legal_default',
    path: '/bbses'
  },
  {
    parentCategoryId: 6,
    alt: 'みんなが投稿した弁護士への無料Q&A公開中',
    cnClicked: 'banner_trip',
    img: 'legal_default',
    path: '/bbses'
  },
  {
    parentCategoryId: 8,
    alt: 'みんなが投稿した弁護士への無料Q&A公開中',
    cnClicked: 'banner_hoby',
    img: 'legal_default',
    path: '/bbses'
  },
  {
    parentCategoryId: 9,
    alt: 'みんなが投稿した弁護士への無料Q&A公開中',
    cnClicked: 'banner_ portrait',
    img: 'legal_default',
    path: '/bbses'
  },
  {
    parentCategoryId: 10,
    alt: '【初回相談無料】ビジネスの法律相談',
    cnClicked: 'banner_movie',
    img: 'legal_trial',
    path: '/special_pages/1'
  },
  {
    parentCategoryId: 11,
    alt: '【初回相談無料】ビジネスの法律相談',
    cnClicked: 'banner_programing',
    img: 'legal_trial',
    path: '/special_pages/1'
  },
  {
    parentCategoryId: 12,
    alt: 'みんなが投稿した弁護士への無料Q&A公開中',
    cnClicked: 'banner_job',
    img: 'legal_default',
    path: '/bbses'
  },
  {
    parentCategoryId: 13,
    alt: '【初回相談無料】ビジネスの法律相談',
    cnClicked: 'banner_bussiness',
    img: 'legal_trial',
    path: '/special_pages/1'
  },
  {
    parentCategoryId: 14,
    alt: '【初回相談無料】ビジネスの法律相談',
    cnClicked: 'banner_language',
    img: 'legal_trial',
    path: '/special_pages/1'
  },
  {
    parentCategoryId: 15,
    alt: 'みんなが投稿した弁護士への無料Q&A公開中',
    cnClicked: 'banner_other',
    img: 'legal_default',
    path: '/bbses'
  },
  {
    parentCategoryId: 16,
    alt: '【初回相談無料】ビジネスの法律相談',
    cnClicked: 'banner_marketing',
    img: 'legal_trial',
    path: '/special_pages/1'
  },
  {
    parentCategoryId: 17,
    alt: 'みんなが投稿した弁護士への無料Q&A公開中',
    cnClicked: 'banner_doblework',
    img: 'legal_default',
    path: '/bbses'
  },
  {
    parentCategoryId: 18,
    alt: '【初回相談無料】ビジネスの法律相談',
    cnClicked: 'banner_design',
    img: 'legal_trial',
    path: '/special_pages/1'
  },
  {
    parentCategoryId: 19,
    alt: '【初回相談無料】ビジネスの法律相談',
    cnClicked: 'banner_righting',
    img: 'legal_trial',
    path: '/special_pages/1'
  },
  {
    parentCategoryId: 22,
    alt: '【初回相談無料】ビジネスの法律相談',
    cnClicked: 'banner_web',
    img: 'legal_trial',
    path: '/special_pages/1'
  },
  {
    parentCategoryId: 23,
    alt: 'みんなが投稿した弁護士への無料Q&A公開中',
    cnClicked: 'banner_music',
    img: 'legal_default',
    path: '/bbses'
  },
  {
    parentCategoryId: 24,
    alt: '【初回相談無料】ビジネスの法律相談',
    cnClicked: 'banner_consultant',
    img: 'legal_trial',
    path: '/special_pages/1'
  },
  {
    parentCategoryId: 25,
    alt: '【初回相談無料】ビジネスの法律相談',
    cnClicked: 'banner_specialist',
    img: 'legal_trial',
    path: '/special_pages/1'
  }
]

export default {
  name: 'ServiceSearchLegalBanner',
  props: {
    parentCategoryId: {
      type: Number,
      default: null
    },
    isBusiness: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('constants', ['LEGAL_URL']),
    ...mapGetters('ui', ['isTB', 'isSP']),
    searchLegalBanner() {
      const legalBanner =
        this.parentCategoryId &&
        LEGAL_BANNER_CATEGORY.some(b => b.parentCategoryId === this.parentCategoryId)
          ? LEGAL_BANNER_CATEGORY.find(b => b.parentCategoryId === this.parentCategoryId)
          : LEGAL_BANNER_DEFAULT
      if (this.isBusiness) {
        return { ...legalBanner, cnClicked: 'business_' + legalBanner.cnClicked }
      }
      return legalBanner
    },
    searchLegalBannerTo() {
      // SPの判定が返ってくるまではPCをセットしておく
      let cnDevice = 'pc'
      if (this.isSP) {
        cnDevice = 'sp'
      }
      if (this.parentCategoryId === 1) {
        return `${this.LEGAL_URL}${this.searchLegalBanner.path}&cn_device=${cnDevice}&cn_clicked=${
          this.searchLegalBanner.cnClicked
        }`
      }
      return `${this.LEGAL_URL}${this.searchLegalBanner.path}?cn_device=${cnDevice}&cn_clicked=${
        this.searchLegalBanner.cnClicked
      }`
    }
  },
  methods: {
    imagePath(img) {
      // SPの判定が返ってくるまではPCをセットしておく
      let device = 'pc'
      if (this.isSP || this.isTB) {
        device = 'sp'
      }
      return require(`@/assets/images/common/banner/${this.searchLegalBanner.img}_${device}.jpg`)
    }
  }
}
</script>
<style lang="scss" scoped>
.c-searchLegalBanner {
  margin-top: 20px;
  text-align: center;

  &_banner {
    margin: 0 auto;
    display: inline-block;
    @include link-effect;

    img {
      width: 100%;
    }
  }
}

@media (max-width: breakpoint(Search, M)) {
  .c-searchLegalBanner {
    max-width: 500px;
    margin: 0 auto;
    padding: 0 0 10px;

    &_banner {
      display: block;
      width: auto;
      max-width: 500px;
    }
  }
}

@media (max-width: breakpoint(Search, S)) {
  .c-searchLegalBanner {
    padding: 0 10px 10px;
  }
}
</style>
